





































import AbpBase from "../../../lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { SaveModuleColumn } from "../../../api/systemBasic";

@Component({})
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;

  form: any = {};
  saveLoading = false;
  rules: any = {
    sort: [{ required: true, message: "请输入显示顺序", trigger: "blur" }],
  };

  created() {
    if (this.data) {
      this.form = Object.assign({}, this.data);
    }
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }
  isReg(reg:any) {
		let isReg;
		try {
	  	isReg= 	new RegExp((reg))  instanceof RegExp
		} catch (e) {
			isReg = false
		}
		return isReg
	}
  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.isReg(this.form.columnRegex)){
        this.saveLoading = true;
        let res = await SaveModuleColumn(this.form);
        if (res.status == 1) {
          this.$emit("onModuleColumnSave");
          this.$emit("input", false);
        }
        this.saveLoading = false;
      }else{
        this.$Message.error("校验规则填写有误")
      }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/moduleColumnSetting/addOrEdit.vue